module.exports = __webpack_public_path__ + "static/img/logo.6d1a899a.png";